import React, { useEffect } from 'react'

import { AcornsIcon } from '@acorns/icons'
import { Card, CardContent, Heading } from '@acorns/web-components'
import { WithOptimizelyProps, withOptimizely } from '@optimizely/react-sdk'
import styled from 'styled-components'

import { TestIDs } from 'test/utils/testIds'
import { style } from 'theme'
import trackEvent from 'utils/analytics/trackEvent'
import { maintenanceScreenWeb } from 'utils/Optimizely/features'

import { resolveMaintenanceScreenViewedEvent } from './events'

type InnerProps = WithOptimizelyProps

const Maintenance = (props: InnerProps) => {
  const optimizely = props.optimizely

  const variables = optimizely.getFeatureVariables(maintenanceScreenWeb) as {
    title: string
    details: string
  }

  const defaultTitle = 'Under Maintenance'
  const defaultDetails =
    "We are currently performing our routine maintenance on our systems. Don't worry, we will be back shortly!"
  const title = variables?.title || defaultTitle
  const details = variables?.details || defaultDetails

  const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${style(theme => theme.colors.ivory)};
    height: 100vh;
    padding: 20px;
  `

  const StyledCard = styled(Card)`
    max-width: 500px;
    min-height: 300px;
  `

  const StyledCardContent = styled(CardContent)`
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    min-height: 300px;
  `

  const Title = styled(Heading)`
    text-align: center;
    padding: 20px 0;
  `

  const Details = styled.p`
    font-size: 14px;
    font-weight: normal;
    line-height: 22px;
    color: ${style(theme => theme.colors.slate)};
    text-align: center;
    margin: 0;
  `

  useEffect(() => {
    trackEvent('Screen Viewed', {
      eventData: resolveMaintenanceScreenViewedEvent(),
    })
  }, [])

  return (
    <Container>
      <StyledCard data-testid={TestIDs.MAINTENANCE.CARD}>
        <StyledCardContent padding={'large'}>
          <AcornsIcon icon={AcornsIcon.Icon.AcornsLogo} width={38} />
          <Title>{title}</Title>
          <Details>{details}</Details>
        </StyledCardContent>
      </StyledCard>
    </Container>
  )
}

export default withOptimizely(Maintenance)
